var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnersSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 454,
    viewBox: "0 0 1920 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.119 81.5948C95.4497 115.632 20.6774 227.253 0 278.809V454H1920V17.0248C1835.46 4.17748 1637.75 -13.8088 1523.29 17.0248C1380.22 55.5667 1277.67 127.645 1074.56 131.65C912.075 134.853 721.042 99.6145 645.836 81.5948C562.626 67.4127 362.789 47.5578 229.119 81.5948Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersSvg);
export default __webpack_public_path__ + "static/media/partnersSvg.fe83b7c74e53f8665a023339d3d8dd40.svg";
export { ForwardRef as ReactComponent };